const namespace = 'student-binder/';

export const INITIALIZE_STUDENT_BINDER = `${namespace}INITIALIZE_STUDENT_BINDER`;

export const STUDENT_BINDER_DATA_LOAD_REQUEST = `${namespace}STUDENT_BINDER_DATA_LOAD_REQUEST`;
export const STUDENT_BINDER_DATA_LOAD_SUCCESS = `${namespace}STUDENT_BINDER_DATA_LOAD_SUCCESS`;
export const STUDENT_BINDER_DATA_LOAD_FAILURE = `${namespace}STUDENT_BINDER_DATA_LOAD_FAILURE`;
